/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */

/**
 * Request to create a booking
 */
export interface CreateBookingRequest {
  /** ID of the slot to book */
  slotId: string;
  /** Recording consent if required */
  consentGiven?: boolean;
}
